import { Accordion, Link, LinkList, Text } from '@postenbring/hedwig-react';

const Items = ({ items }) => (
    <LinkList>
        {items.map(({title, url}) => (
            <li key={url}>
                <Link variant="no-underline" href={url}>
                    {title}
                </Link>
            </li>
        ))}
    </LinkList>
)

const LargeContent = ({ mainContent }) => {
    return mainContent.map(({heading, items}) => (
        <div key={heading}>
            <Text variant='h2' className="hds-mb-12-16">
                {heading}
            </Text>
            <Items items={items} />
        </div>
    ))
}

const SmallContent = ({ mainContent }) => {
    return mainContent.map(({heading, items}) => (
        <Accordion.Item key={heading}>
            <Accordion.Header>
                {heading}
            </Accordion.Header>
            <Accordion.Content>
                <Items items={items} />
            </Accordion.Content>
        </Accordion.Item>
    ))
}

export const MenuMainContent = ({ mainContent }) => (
    <>
        <div className="kp-menu-content-links kp-hidden-before-large">
            <LargeContent mainContent={mainContent} />
        </div>
        <Accordion className="kp-hidden-after-large">
            <SmallContent mainContent={mainContent} />
        </Accordion>
    </>
)
